import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { Spin, message } from 'antd';
import { getTokens } from '@/util/AuthStore';

const LOADING_ROOT_ID = 'share-download-export-loading';

function showDownloadLoading(text = '下载中') {
    let container = document.getElementById(LOADING_ROOT_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = LOADING_ROOT_ID;
        document.body.appendChild(container);
    }

    ReactDOM.render(
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 10000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(0, 0, 0, 0.45)',
            }}
        >
            <Spin size="large" tip={text} />
        </div>,
        container,
    );

    return () => {
        const el = document.getElementById(LOADING_ROOT_ID);
        if (el) {
            ReactDOM.unmountComponentAtNode(el);
            el.parentNode?.removeChild(el);
        }
    };
}

/**
 * 导出文件下载：全屏遮罩 +「下载中」，成功后触发浏览器下载，不弹成功提示
 */
export function downloadExportFile({
    url,
    method = 'post',
    params,
    fileName,
    errorMessage = '导出失败',
    loadingText = '下载中',
}) {
    const hideLoading = showDownloadLoading(loadingText);

    const config = {
        url,
        method,
        responseType: 'blob',
        headers: {
            Authorization: `Bearer ${getTokens()?.access_token}`,
        },
    };
    if (params != null) {
        if (method.toLowerCase() === 'get') {
            config.params = params;
        } else {
            config.data = params;
        }
    }

    return axios(config)
        .then(response => {
            if (response.status !== 200) {
                message.error(errorMessage);
                return;
            }
            const blob = response.data;
            if (!(blob instanceof Blob) || blob.size === 0) {
                message.error(errorMessage);
                return;
            }
            const ct = response.headers['content-type'] || '';
            if (ct.includes('application/json')) {
                return new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        try {
                            const json = JSON.parse(reader.result);
                            message.error(json.message || errorMessage);
                        } catch {
                            message.error(errorMessage);
                        }
                        resolve();
                    };
                    reader.readAsText(blob);
                });
            }
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
        })
        .catch(() => {
            message.error(errorMessage);
        })
        .finally(() => {
            hideLoading();
        });
}
